import React from 'react'
import { Box } from '@mui/material'
import TextValue from '../../../../../text/TextValue'
import SectionCollapse from '../../../../../section/SectionCollapse'
import PaperBase from '../../../../../Paper/PaperBase'

// MF-531: audit log for the LC bulk hard delete. Lists each deleted learning
// continuum by its identifying elements (lcElements) plus the curriculum —
// deliberately without the LC levels.
const LearningContinuumBulkDeleted = ({ detail = {} }) => {
  const deleted = Array.isArray(detail?.deleted) ? detail.deleted : []
  const curriculumLabel = detail?.curriculum?.shortName
    ? `${detail.curriculum.shortName} - ${detail.curriculum.name || ''}`
    : detail?.curriculum?.name || '—'

  const elementsLabel = (lc) =>
    Object.values(lc?.lcElements || {})
      .filter(Boolean)
      .join('  ·  ') || '—'

  return (
    <Box className='py-1 flex flex-col gap-2 w-full'>
      <TextValue title='Curriculum' value={curriculumLabel} />
      <SectionCollapse title={`Deleted learning continua (${deleted.length})`}>
        <div className='flex flex-col gap-1 w-full'>
          {deleted.map((lc, idx) => (
            <div className='flex flex-nowrap w-full gap-1' key={lc?._id || idx}>
              <PaperBase className='font-bold min-w-120px max-w-120px overflow-hidden'>
                {`v${lc?.version || 1}`}
              </PaperBase>
              <PaperBase className='w-full overflow-auto'>{elementsLabel(lc)}</PaperBase>
            </div>
          ))}
        </div>
      </SectionCollapse>
    </Box>
  )
}

export default LearningContinuumBulkDeleted
